const DEFAULT_ROUTE = { name: 'dashboard', path: '/', params: {}, query: new URLSearchParams() };

export function parseHash(hash = globalThis.location?.hash || '#/') {
  const raw = String(hash || '#/').replace(/^#/, '') || '/';
  const [pathPart, queryPart = ''] = raw.split('?');
  const path = normalizePath(pathPart);
  const query = new URLSearchParams(queryPart);
  const segments = path.split('/').filter(Boolean).map(decodeURIComponent);

  if (path === '/') return { ...DEFAULT_ROUTE, query };
  if (segments[0] === 'transactions' && segments.length === 1) return { name: 'transactions', path, params: {}, query };
  if (segments[0] === 'tx' && segments[1]) return { name: 'tx', path, params: { hash: segments[1] }, query };
  if (segments[0] === 'transactions' && segments[1]) return { name: 'tx', path, params: { hash: segments[1] }, query };
  if (segments[0] === 'wallets' && segments.length === 1) return { name: 'wallets', path, params: {}, query };
  if (segments[0] === 'wallet' && segments[1]) return { name: 'wallet', path, params: { id: segments[1] }, query };
  if (segments[0] === 'wallets' && segments[1]) return { name: 'wallet', path, params: { id: segments[1] }, query };
  if (segments[0] === 'dsr' && segments.length === 1) return { name: 'dsr', path, params: {}, query };
  if (segments[0] === 'dsr' && segments[1]) return { name: 'dsrDetail', path, params: { id: segments[1] }, query };
  if (segments[0] === 'zk' && segments.length === 1) return { name: 'zk', path, params: {}, query };
  if (segments[0] === 'zk' && segments[1]) return { name: 'zkDetail', path, params: { id: segments[1] }, query };

  return { name: 'notFound', path, params: {}, query };
}

export function normalizePath(path) {
  const s = `/${String(path || '').replace(/^\/+/, '')}`.replace(/\/+$/, '');
  return s === '' ? '/' : s;
}

export function routeHref(path, params = {}) {
  const query = buildRouteQuery(params);
  return `#${normalizePath(path)}${query ? `?${query}` : ''}`;
}

export function buildRouteQuery(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    const s = String(value).trim();
    if (s === '') return;
    q.set(key, s);
  });
  return q.toString();
}

export function queryToObject(query) {
  const out = {};
  for (const [key, value] of query.entries()) out[key] = value;
  return out;
}
